import React, { Component } from 'react';
import './styles.css';
import Label from './Label';
import Stepper from './Stepper';

class SubmissionStepperLayout extends Component {
	render() {
		return (
			<div className="submission-stepper-layout">{this.props.children}</div>
		);
	}
}

Object.assign(SubmissionStepperLayout, {
	Label,
	Stepper
});

export default SubmissionStepperLayout;
